import React from 'react'
import styled from 'styled-components'

const DriverStatBarSm = ({result, barColor = "#f58220"}) => {
  return (
    <BarContainer className="driver-stat-bar">
      <ResultBar style={{ width: `${result || 0}%`, backgroundColor: barColor }} />
    </BarContainer>
  )
}

export default DriverStatBarSm;

const BarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 90px;
  height: 14px;
  border-radius: 3px;
  border-radius: 3px;
  background-color: #f4f3f1;
  overflow: hidden;
`;

const ResultBar = styled.div`
  height: 100%;
  border-radius: 3px;
`;


// WEBPACK FOOTER //
// ./src/components/ui/driver-stat-bar-sm.js